import { createSlice } from '@reduxjs/toolkit';
import { getCalculation } from './proposalsActions';
import { Status } from 'lib/enums';
import { RootState } from 'reducers/store';

type CalculationState = {
    data: any | null;
    status: Status;
    error: string | null;
};

const initialState: CalculationState = {
    data: null,
    status: Status.Idle,
    error: null,
};

const proposalSlice = createSlice({
    name: 'proposal',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCalculation.pending, (state) => {
                state.status = Status.Pending;
                state.error = null;
            })
            .addCase(getCalculation.rejected, (state, action) => {
                state.status = Status.Rejected;
                state.error = action.payload?.error ?? 'An error occurred';
            })
            .addCase(getCalculation.fulfilled, (state, action) => {
                state.status = Status.Success;
                state.data = action.payload.data ?? null;
            });
    },
});

// Selector to check if the calculation is loading
export const selectCalculationData = (state: RootState) => state.proposal.data; 
export const selectCalculationStatus = (state: RootState): boolean => state.proposal.status === Status.Pending;


// Export the reducer
export default proposalSlice.reducer;
